// extracted by mini-css-extract-plugin
export default {"homePage":"home_homePage__SWtjc","homeImg":"home_homeImg__3-SFr"};